import { useEffect, useState } from "react";
import { getSettings, updateSettings } from "../../api/settings";
import { Button, Card, Label, TextInput, ToggleSwitch } from "flowbite-react";
import toast from "react-hot-toast";

const Settings = () => {
  const [isProcessing, setIsProcessing] = useState(false);

  const [formData, setFormData] = useState({
    testMode: false,
    testEmail: '',
  });

  const fetchSettings = async () => {
    try {
      const settings = await getSettings();
      
      settings.map(setting => {
        setFormData(prevState => ({
          ...prevState,
          [setting.key]: setting.value === 'false' ? false : setting.value,
        }));

        return true;
      });
    } catch (error) {
      console.error(error);
    }
  }

  const handleChange = e => {
    const { name, value } = e.target;

    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  }

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsProcessing(true);

    try {
      await updateSettings(formData);

      toast.success('Settings have been saved');
    } catch (error) {
      console.error(error);
      toast.error('Unable to save settings');
    } finally {
      setIsProcessing(false);
    }
  }

  return (
    <div className="p-4">
      <Card>
        <h1 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Settings</h1>
        <form
          className="space-y-4"
          onSubmit={handleSubmit}
        >
          <div>
            <ToggleSwitch
              checked={formData.testMode}
              label="Enable test mode"
              onChange={() => {
                handleChange({
                  target: {
                    name: 'testMode',
                    value: !formData.testMode,
                  }
                });
              }}
              theme={{
                toggle: {
                  base: 'after:rounded-full rounded-full border group-focus:ring-4 group-focus:ring-cyan-500/25',
                  checked: {
                    on: 'after:bg-white after:translate-x-full',
                    off: 'after:bg-gray-400 dark:after:bg-gray-500 border-gray-200 bg-gray-200 dark:border-gray-600 dark:bg-gray-700',
                  },
                },
              }}
            />
          </div>
          <div>
            <div className="mb-2 block">
              <Label htmlFor="testEmail" value="Test Email" />
            </div>
            <TextInput
              id="testEmail"
              name="testEmail"
              value={formData.testEmail}
              onChange={handleChange}
              required
            />
          </div>
          <Button
            isProcessing={isProcessing}
            disabled={isProcessing}
            type="submit"
          >
            Save
          </Button>
        </form>
      </Card>
    </div>
  );
}

export default Settings;
